import { useSelector } from 'react-redux';

import CartSummary from 'common/components/summary/Summary';

const Summary = ({ showTotalRemaining }) => {
  const cart = useSelector((state) => state.cart.data);

  let type = 'Estimate';
  if (cart.orderDeliveryMethod === 'Ship' && cart.shipping?.length > 0) {
    type = 'Actual';
  }
  if (cart.orderDeliveryMethod === 'Pickup' && cart.taxes?.length > 0) {
    type = 'Actual';
  }
  if (cart.orderDeliveryMethod === 'Carry Out' && cart.taxes?.length > 0) {
    type = 'Actual';
  }
  return (
    <>
      <CartSummary
        cartOrOrder={cart}
        showGiftCards
        showLoyaltyPoints
        showTotalRemaining={showTotalRemaining}
        type={type}
      />
    </>
  );
};

export default Summary;
